import { yupResolver } from '@hookform/resolvers/yup';
import { UseFormProps, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

export interface IExperienceFormInputs {
  email: string;
  consent: boolean;
}

const defaultValues = {
  email: '',
  consent: false
};

export const useExperienceForm = (options?: UseFormProps<IExperienceFormInputs>) => {
  const { t } = useTranslation();

  const emailValidation = t('Please enter a valid email');
  const consentValidation = t('You must accept the Terms of Service and Privacy Policy.');

  const schema = yup.object().shape({
    email: yup.string().email(emailValidation).required(emailValidation),
    consent: yup.boolean().oneOf([true], consentValidation).required(consentValidation)
  });

  const formMethods = useForm<IExperienceFormInputs>({
    resolver: yupResolver(schema),
    mode: 'onBlur',
    defaultValues,
    ...options
  });

  return formMethods;
};
